var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":_vm.fluid}},[_c('v-card',{attrs:{"flat":_vm.flat}},[(_vm.title)?_c('v-card-title',[_vm._t("title")],2):_vm._e(),_c('v-card-text',[_c('v-row',{attrs:{"justify":_vm.justificar}},[_vm._t("content")],2)],1),(_vm.actions)?_c('v-card-actions',[_vm._t("acao")],2):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }